<template>
  <div class="menu--item menu--item-highlighted_box" v-if="isScheduled || $store.state.isAdminView"
       :data-menu-item-id="item.mi_id" :class="{'menu--item-highlighted': (item.mi_highlight === 1)}"
       :id="'menu--item-' + item.mi_id">
    <menu-tag v-for="tag in item.tags" :key="tag.mt_id" :tag="tag" menu-type="visual"></menu-tag>
    <h3 class="menu--item_title">
      <span v-html="item.mi_title"></span>
      <menu-item-price v-if="item.price_display.length" :price-to-display="item.price_display"
                       :price-label="item.price_label"></menu-item-price>
    </h3>

    <menu-schedules v-if="$store.state.isAdminView && item.normalizedSchedules.length"
                    :normalized-schedules="item.normalizedSchedules"></menu-schedules>
    <p v-if="item.mi_description.length" class="menu--item_description" v-html="item.mi_description"></p>
  </div>
</template>

<script lang="ts">
/**
 * Custom component for highlighted menu items with a containing box.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.3.0
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <menu-item-highlighted-box> shows a menu item in an especially highlighting layout.
 *
 *    2024-12-16 (1.1.0) (jhoward)
 *      - Reorganize the <menu-item-highlighted-box> component to support menu tags on the right side and new layout from Advertising.
 *
 *    2025-02-10 (1.2.0) (jhoward)
 *      - Add <menu-schedules> to the <menu-item-highlighted-box> component if in admin view.
 *      - Add scheduling support to the <menu-item-highlighted-box> component.
 *
 *    2025-04-08 (1.3.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <MenuItemHighlightedBox>.
 *      - Use <menu-item-price> in <MenuItemHighlightedBox>.
 */

import MenuTag from "../menu-tag.vue";
import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import MenuItemPrice from "./MenuItemPrice.vue";

export default defineComponent({
  name: 'MenuItemHighlightedBox',
  components: {
    MenuItemPrice,
    MenuSchedules,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    isScheduled: computedIsScheduled,
  }
})
</script>

<style scoped>
.menu--item-highlighted_box {
  position: relative;
  border: 0.125em solid #000;
  padding: 0.5em;
  grid-column: 1 / -1;
}

.menu--item_title {
  position: relative;
  font-size: 0.9em;
  font-weight: bold;
}

.menu--tag ~ .menu--item_title {
  padding-right: 7.5em;
}

.menu--item_description {
  font-weight: 300;
  align-self: center;
  margin: 0;
}

.menu--item-highlighted {
  background-color: #f7f3eb;
}

.menu--item-highlighted_box:deep(.menu--item_price) {
  margin-left: 1em;
}

.menu--tag {
  float: right;
  width: 4.5em;
  height: 4.5em;
}
</style>